import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { Form, Formik, FormikErrors } from "formik";
import moment from "moment";

import Loading from "../../components/loading/loading";
import TextFieldDateComponent from "../../components/textfielddate/textfield-date-mui";
import { IFormCrrReport } from "../../interfaces/IFormCrrReport";
import { IFormQuestionnaireReport } from "../../interfaces/IFormQuestionnaireReport";
import { homeStyle } from "../../styles/container/home";
import useViewModel from "./ViewModel";

function QuestionnaireReport() {
  const {
    data: { loadingActive },
    method: { exportReport },
  } = useViewModel();

  const initialValues: IFormQuestionnaireReport = {
    startDate: moment().format("YYYY-MM-DD").toString(),
    endDate: moment().format("YYYY-MM-DD").toString(),
  };

  const validation = (values: IFormQuestionnaireReport) => {
    const errors: FormikErrors<IFormCrrReport | undefined> = {};

    if (values.startDate === "") {
      errors.startDate = "Start Date must be filled";
    }

    if (
      values.startDate !== null &&
      values.endDate != null &&
      values.startDate > values.endDate
    ) {
      errors.endDate = "End Date must not be earlier than Start Date";
    }

    return errors;
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        Questionnaire Report
        <hr />
      </Box>
      <br />

      <Formik
        initialValues={initialValues}
        onSubmit={(values) => exportReport(values)}
        validate={validation}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item lg={6} md={6} xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  <u>
                    Tanggal Awal / <i>Start Date </i>
                  </u>
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <TextFieldDateComponent propsData={props} name="startDate" />
                {props.errors.startDate && (
                  <div className="error-message">{props.errors.startDate}</div>
                )}
              </Grid>

              <Grid item lg={6} md={6} xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  <u>
                    Tanggal Akhir / <i>End Date </i>
                  </u>
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <TextFieldDateComponent propsData={props} name="endDate" />
                {props.errors.endDate && (
                  <div className="error-message">{props.errors.endDate}</div>
                )}
              </Grid>
            </Grid>

            <br />
            <div
              style={{ display: "flex", justifyContent: "center", gap: "3%" }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  textTransform: "none",
                  width: "150px",
                }}
              >
                Export
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      <Loading open={loadingActive} />
    </Container>
  );
}

export default QuestionnaireReport;
